import React from 'react';
import * as Icons from 'lucide-react';

const SkillCategory = ({ title, skills, icon }) => {
  const IconComponent = Icons[icon];
  
  return (
    <div className="bg-card rounded-lg p-6 shadow-lg hover:shadow-xl transition-shadow h-full flex flex-col">
      <div className="flex items-center gap-3 mb-4">
        {IconComponent && (
          <div className="text-primary">
            <IconComponent size={24} />
          </div>
        )}
        <h3 className="text-xl font-semibold">{title}</h3>
      </div>
      <ul className="space-y-2 flex-grow">
        {skills.map((skill, index) => (
          <li key={index} className="text-muted-foreground">
            {skill}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SkillCategory;
